<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center">
        <v-flex xs12>
          <h3 class="text-center">Service Items</h3>
          <v-btn small outlined href="/serviceItems/create" color="primary" text @click.stop.prevent="goTo('/serviceItems/create')" v-if="canCreate" class="pull-right">
            <v-icon left>mdi-grid</v-icon>
            Create New
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout wrap align-center justify-center>
        <v-flex xs6 sm4 md4 class="pa-1" v-for="item in service_items" :key="item.id">
          <v-card elevation="24">
            <v-card-text>
              <service-items-component :service_item="item"></service-items-component>
            </v-card-text>
            <v-card-actions class="ma-1">
              <ordering-buttons :service_item="item" :disabled="orderingDisabled" @disableOrder="ordering(true)" @enableOrder="ordering(false)" :count="count"></ordering-buttons>
              <v-spacer></v-spacer>
              <v-btn small color="warning" @click="goTo('/serviceItems/' + item.id + '/edit')" text icon title="Edit item" v-if="!item.deleted_at">
                <v-icon>{{ icons.edit }}</v-icon>
              </v-btn>
              <delete-button :service_item="item" :key="item.deleted_at + Math.random()"></delete-button>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'
  const ServiceItemsComponent = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/Pages/components/serviceItem')
  const deleteButton = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "service-items" */ '@/Components/ServiceItems/deleteItem')
  const orderingButtons = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "service-items" */ '@/Components/ServiceItems/changeOrder')

  export default {
    name: 'ServiceItemsIndex',
    layout,
    props: [
      'service_items',
      'canCreate',
      'count'
    ],
    components: {
      ServiceItemsComponent,
      deleteButton,
      orderingButtons,
    },
    metaInfo () {
      return {
        title: 'Service Items',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        filterBy: '',
        orderingDisabled: false
      }
    },
    methods: {
      ordering (state) {
        this.orderingDisabled = state
      },
    },
  }
</script>
